var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-container"},[_c('div',{staticClass:"wtic"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"c-main",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }